<template>
  <div>
    <main>
      <div class="WorkM_MainArea">
        <b-container fluid style="max-width: 500px">
          <div class="WorkM_ChangeTargetMonthArea">
            <div class="ChangeTargetMonthButton"><b-icon icon="chevron-left" @click="clickBeforeMonth()"></b-icon></div>
            <div class="DispYearMonth">{{ targetYear }}年{{ targetMonth }}月</div>
            <div class="ChangeTargetMonthButton"><b-icon icon="chevron-right" @click="clickNextMonth()"></b-icon></div>
          </div>
          <!--  -->
          <div class="WorkM_CalendarArea">
            <table class="WorkM_CalendarTable">
              <thead>
                <tr>
                  <th v-for="(day, index) in weekDays" :key="index">{{ day }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(week, index) in calendar" :key="index">
                  <td
                    v-for="(dateData, idx) in week"
                    :key="idx"
                    :class="[
                      'calendar-cell',
                      { CalendarCel_OtherMonth: dateData.dateType == 99 },
                      { CalendarCel_TypeBlue: dateData.dateType == 1 },
                      { CalendarCel_TypeRed: dateData.dateType == 2 },
                      { CalendarCel_isConfirmed: dateData.isConfirmedDate == true },
                    ]"
                    @click="clickDate(dateData)"
                  >
                    <div class="CelContent">
                      <div class="CelContent_DispDayLabel d-flex justify-content-between">
                        <div v-if="!emptyCheck(dateData.dispDay)">
                          <div class="mb-0" v-if="dateData.mustConfirmDate">{{ dateData.dispDay + '*' }}</div>
                          <div class="mb-0" v-else>{{ dateData.dispDay }}</div>
                        </div>
                        <div v-if="!emptyCheck(dateData.workApprovalStatus)">
                          <div class="mb-0 approvalIcon" v-if="dateData.workApprovalStatus == 0"></div>
                          <div class="mb-0 approvalIcon" v-if="dateData.workApprovalStatus == 1">△</div>
                          <div class="mb-0 approvalIcon" v-if="dateData.workApprovalStatus == 2">△</div>
                          <div class="mb-0 approvalIcon" v-if="dateData.workApprovalStatus == 3">○</div>
                          <div class="mb-0 approvalIcon" v-if="dateData.workApprovalStatus == 4">✕</div>
                          <div class="mb-0 approvalIcon" v-if="dateData.workApprovalStatus == 5">▲</div>
                        </div>
                        <div v-else-if="!emptyCheck(dateData.applicationStatus)">
                          <div class="mb-0 approvalIcon" v-if="dateData.applicationStatus == 0"></div>
                          <div class="mb-0 approvalIcon" v-if="dateData.applicationStatus == 1">△</div>
                          <div class="mb-0 approvalIcon" v-if="dateData.applicationStatus == 2">△</div>
                          <div class="mb-0 approvalIcon" v-if="dateData.applicationStatus == 3">○</div>
                          <div class="mb-0 approvalIcon" v-if="dateData.applicationStatus == 4">✕</div>
                          <div class="mb-0 approvalIcon" v-if="dateData.applicationStatus == 5">▲</div>
                        </div>
                      </div>
                      <div class="CelContent_DispValueArea">
                        <div v-if="dateData.dateType != 99 && dateData.workingStatus > 0">
                          <div v-if="dateData.workingStatus == 11" class="CalendarDispValue_AttendanceColor CalendarDispValue_Circle">出</div>
                          <div v-else-if="dateData.workingStatus == 12" class="CalendarDispValue_AttendanceColor CalendarDispValue_Triangle">出</div>
                          <div v-else-if="dateData.workingStatus == 21" class="CalendarDispValue_RestColor CalendarDispValue_Circle">有</div>
                          <div v-else-if="dateData.workingStatus == 22" class="CalendarDispValue_RestColor CalendarDispValue_Triangle">有</div>
                          <div v-else-if="dateData.workingStatus == 23" class="CalendarDispValue_RestColor CalendarDispValue_Circle">特</div>
                          <div v-else-if="dateData.workingStatus == 24" class="CalendarDispValue_RestColor CalendarDispValue_Triangle">特</div>
                          <div v-else-if="dateData.workingStatus == 99" class="CalendarDispValue_NotSubmitColor CalendarDispValue_Cross">未</div>
                        </div>
                      </div>
                      <div class="position-relative CelContent_DispOverTimeArea">
                        <div v-if="dateData.hasOverwork" class="CelContent_DispOverTimeLabel">残業</div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mt-3 mb-1 border rounded-sm explainIconArea">
              <div>
                <label class="mb-0 mr-2"><span class="mb-0 px-1">*</span>: 未確定</label>
                <label class="mb-0 mr-2"><span class="mb-0 pr-1">残業</span>: 残業あり</label>
              </div>
              <div>
                <label class="mb-0 mr-2"><span class="mb-0 pr-1">△</span>: 未承認</label>
                <label class="mb-0 mr-2"><span class="mb-0 pr-1">○</span>: 承認</label>
                <label class="mb-0 mr-2"><span class="mb-0 pr-1">✕</span>: 否認</label>
                <label class="mb-0 mr-2"><span class="mb-0 pr-1">▲</span>: 一部否認</label>
              </div>
            </div>
          </div>
        </b-container>
      </div>
    </main>
  </div>
</template>
  
<script>
import config from "../../const/config";
export default {
  name: "WorkCalendar",
  components: {},
  data() {
    return {
      systemVersion: null,
      dispDate: null,
      dispDayOfWeek: null,
      targetYear: 0,  // 表示する年
      targetMonth: 0, // 表示する月
      weekDays: ["日", "月", "火", "水", "木", "金", "土"], // 曜日
      applicationList: [],
      calendarTypeList: [],
      loginUserId: null,
      items: null,
      currentDate: "", // システム日付
    };
  },
  computed: {
    calendar() {
      // 対象月の開始日
      const firstDayOfMonth = new Date(this.targetYear, this.targetMonth - 1, 1);
      // 対象月の終了日
      const lastDayOfMonth = new Date(this.targetYear, this.targetMonth, 0);

      // 曜日番号取得(0:日～7:土)
      const startDayOfWeek = firstDayOfMonth.getDay();

      // 描画開始日取得 (日曜始まりにするため、"対象月の開始日の曜日番号"分マイナスした日付となる)
      let calendarStartDate = new Date(firstDayOfMonth);
      calendarStartDate.setDate(calendarStartDate.getDate() - startDayOfWeek);

      const weeks = []; // カレンダーの週ごとのデータを格納する配列
      let currentDate = new Date(calendarStartDate); //処理日

      while (currentDate <= lastDayOfMonth || weeks.length < 6) {
        const week = [];
        for (let i = 0; i < 7; i++) {
          //セルの表示日
          const day = currentDate.getDate();
          //対象月と違う月（前月or翌月）
          const isPrevMonth = currentDate.getMonth() !== this.targetMonth - 1;
          //セルの"yyyy-mm-dd"形式の日付文字列取得
          const dateString = `${currentDate.getFullYear()}/${String(currentDate.getMonth() + 1).padStart(
            2,
            "0"
          )}/${String(day).padStart(2, "0")}`;

          let dateData = {
            workingStatus: 0,
            dispDay: day,
            isPrevMonth: isPrevMonth,
            dateType: 0,
            isConfirmedDate: false,
            mustConfirmDate: false,
            applicationStatus: 0,
            workApprovalStatus: 0,
          };
          if (this.applicationList != null) {
            this.applicationList.forEach((element) => {
              if (this.getStrDateSlash(element.targetDate) === dateString) {
                dateData.workingStatus = element.workingStatus;
                dateData.hasOverwork = element.hasOverwork;
                dateData.applicationStatus = element.applicationStatus;
                dateData.workApprovalStatus = element.workApprovalStatus;
              }
            });
          }
          if (isPrevMonth) {
            dateData.isConfirmedDate = false;
            dateData.mustConfirmDate = false;
            dateData.dateType = 99;
          } else if (this.calendarTypeList != null) {
            this.calendarTypeList.forEach((element) => {
              if (element.targetDate === dateString) {
                dateData.dateType = element.dateType;
                dateData.isConfirmedDate = element.confirmFlg;
                dateData.mustConfirmDate = element.mustConfirmFlg;
              }
            });
          }
          week.push(dateData);
          currentDate.setDate(day + 1);
        }
        weeks.push(week);
      }
      return weeks;
    },
  },
  watch: {},
  mounted: function () {
    this.systemVersion = this.$store.getters.getSystemVersion;
    this.dispDate = this.getStrDateSlash();
    this.dispDayOfWeek = this.getDayOfWeek();
    this.loginUserId = this.$store.state.user_id;
    this.getCalendarInfo();
  },

  methods: {
    // 左矢印ボタンを押した際、表示されている月よりも1カ月前の月を表示する
    clickBeforeMonth: function () {
      if (this.targetMonth == 1) {
        this.targetMonth = 12;
        this.targetYear--;
      } else {
        this.targetMonth--;
      }
      this.getCalendarInfo();
    },
    // 右矢印ボタンを押した際、表示されている月よりも1ヶ月後の月を表示する
    clickNextMonth: function () {
      if (this.targetMonth == 12) {
        this.targetMonth = 1;
        this.targetYear++;
      } else {
        this.targetMonth++;
      }
      this.getCalendarInfo();
    },
    // APIから画面に表示するカレンダー情報を取得する
    getCalendarInfo: function(){
      let targetDate = null;
      if(this.targetYear != 0 && this.targetMonth != 0){
        targetDate = String(this.targetYear).padStart(4, '0') + String(this.targetMonth).padStart(2, '0');
      }
      let paramList = {
          shainCd: this.loginUserId,
          yearMonth: targetDate,
      }
        this.getWithParams(config.URL.CALENDAR, paramList)
        .then((response) => {
          console.debug("response：" + JSON.stringify(response));
          // レスポンスの結果がfalseならエラーメッセージを表示
          if(!response.result){
            this.showAlertError(config.MESSAGE.SERVER_ERROR);
            return;
          }
          this.setCalendarInfo(response.container);
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
    },
    // JSON形式で取得した情報をセットする
    setCalendarInfo: function(items){
      if (this.targetYear == 0 && this.targetMonth == 0)  {
        // 初回のみシステム日付を解析する
        let systemDate = items.currentDate.split('/');
        this.targetYear = systemDate[0];
        this.targetMonth = systemDate[1];
      }
      this.currentDate = items.currentDate;
      this.applicationList = items.applicationList;
      this.calendarTypeList = items.dayTypeList;
    },
    // 日付をクリックした際の動作
    clickDate(dateData){
      const routerWorkRegist = "/manager/WorkRegist"; // 定数：勤怠報告画面遷移
      const routerApplicationRegist = "/manager/ApplicationRegist"; // 定数：事前申請画面遷移
      console.debug("dateData：" + JSON.stringify(dateData));
      // 選択日付が対象月の範囲外なら画面遷移しない
      if(dateData.dateType == 99){
        return;
      }
      let selectDate = new Date(String(this.targetYear).padStart(4, '0') + "/" + String(this.targetMonth).padStart(2, '0') + "/" + String(dateData.dispDay).padStart(2, '0'));
      let currentDate = new Date(this.currentDate);

      let targetDateInfo = {
        target_date: String(this.targetYear).padStart(4, '0') + String(this.targetMonth).padStart(2, '0') + String(dateData.dispDay).padStart(2, '0'),
        is_from_work_calendar: true,
      };
      console.debug("targetDateInfo：" + JSON.stringify(targetDateInfo));

      // 日付がシステム日付を含む以前なら勤怠報告画面へ遷移する
      if(selectDate <= currentDate){
        this.$store.commit("setTargetDateInfo", targetDateInfo);
        this.$router.push(routerWorkRegist);
      }
      // 先日付なら事前申請画面へ遷移する
      else{
        this.$store.commit("setTargetDateInfo", targetDateInfo);
        this.$router.push(routerApplicationRegist);
      }
    },
    // 空文字かチェック
    // true: 空文字
    // false: 空文字ではない
    emptyCheck(text){
      if(text != null && text != ""){
        return false;
      }
      else{
        return true;
      }
    }
  },
};
</script>
<style scoped>
.WorkM_ChangeTargetMonthArea {
  display: flex;
  justify-content: space-around;
  text-align: center;
  /*background: #ececec;*/
  border-bottom: 1px solid rgb(241, 241, 241);
  padding: 0.3rem;
  padding-right: 1rem;
  padding-left: 2rem;
}
.WorkM_ChangeTargetMonthArea .DispYearMonth {
  font-size: 1.2rem;
}
.WorkM_ChangeTargetMonthArea .ChangeTargetMonthButton {
  font-size: 1.2rem;
}

/*  */
.WorkM_CalendarTable {
  width: 100%;
  border-collapse: collapse;
}
.WorkM_CalendarTable th,
.WorkM_CalendarTable td {
  width: 14.28%;
  height: 80px;
  border: 1px solid #ccc;
  text-align: center;
  padding: 0;
}
.WorkM_CalendarTable th {
  height: 50px;
  background: rgb(92, 92, 92);
  color: white;
}
.WorkM_CalendarTable th:first-child {
  background: rgb(207, 90, 90);
}
.WorkM_CalendarTable th:last-child {
  background: rgb(40, 123, 201);
}
/* .WorkM_CalendarTable td:first-child {
  background: rgb(255, 231, 231);
}
.WorkM_CalendarTable td:last-child {
  background: rgb(231, 247, 255);
} */

.WorkM_CalendarTable .CalendarCel_OtherMonth {
  background-color: #f0f0f0 !important;
}
.WorkM_CalendarTable .CalendarCel_TypeRed {
  background-color: rgb(255, 214, 214);
}
.WorkM_CalendarTable .CalendarCel_TypeRed .CelContent_DispDayLabel {
  color: rgb(167, 6, 6);
}
.WorkM_CalendarTable .CalendarCel_TypeBlue {
  background-color: rgb(214, 247, 255);
}
.WorkM_CalendarTable .CalendarCel_TypeBlue .CelContent_DispDayLabel {
  color: rgb(29, 74, 124);
}
.WorkM_CalendarTable .CalendarCel_isConfirmed .CelContent_DispDayLabel {
  color: rgb(92, 92, 92);
}
.WorkM_CalendarTable .CelContent_DispDayLabel {
  padding: 5px;
  text-align: left;
  height: 20px;
}
.WorkM_CalendarTable .CalendarCel_TypeRed .CelContent_DispOverTimeLabel {
  color: rgb(167, 6, 6);
}
.WorkM_CalendarTable .CalendarCel_TypeBlue .CelContent_DispOverTimeLabel {
  color: rgb(29, 74, 124);
}
.WorkM_CalendarTable .CalendarCel_isConfirmed .CelContent_DispOverTimeLabel {
  color: rgb(92, 92, 92);
}
.CelContent_DispOverTimeArea{
  height:10px;
}
.WorkM_CalendarTable .CelContent_DispOverTimeLabel {
  position:absolute;
  left: 0;
  right:0;
  bottom:0;
  font-size: 12px;
}
.WorkM_CalendarTable .CelContent_DispValueArea {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 50px;
  color: rgb(240, 104, 104);
}
.WorkM_CalendarTable .CelContent_DispValueArea .CalendarDispValue {
  background-color: rgb(240, 104, 104);
  color: white;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
.WorkM_CalendarTable .CelContent_DispValueArea .CalendarDispValue_AttendanceColor {
  background-color: rgb(104, 200, 104);
  color: white;
}
.WorkM_CalendarTable .CelContent_DispValueArea .CalendarDispValue_RestColor {
  background-color: rgb(240, 104, 104);
  color: white;
}
.WorkM_CalendarTable .CelContent_DispValueArea .CalendarDispValue_NotSubmitColor {
  color: rgb(90, 90, 90);
}
.WorkM_CalendarTable .CelContent_DispValueArea .CalendarDispValue_Circle {
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
.WorkM_CalendarTable .CelContent_DispValueArea .CalendarDispValue_Triangle {
  width: 30px;
  height: 30px;
  line-height: 40px;
  clip-path: polygon(50% 0,0 100%,100% 100%);
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
.WorkM_CalendarTable .CelContent_DispValueArea .CalendarDispValue_Cross {
  width: 36px;
  border-radius: 50%;
  border: solid 3px rgba(255, 0, 0, 0.4);
  font-size: 20px;
  font-weight: bold;
}
.WorkM_CalendarTable .CelContent_DispDayLabel .approvalIcon {
  color: rgb(29, 74, 124); 
  font-weight:bold;
}
.WorkM_CalendarArea .explainIconArea {
  font-size: 0.8rem; 
  padding: 0.25rem; 
  background-color: rgb(238, 238, 238);
}
</style>
  